<template>
  <div class="auto-process-model">
    <el-dialog class="cellDialog" :visible.sync="chooseNode" width="500px">
      <div class="model">
        <div class="top-nav">
          <div v-for="(item, index) in navs" @click="changeTabs(index)" :key="index" :class="tabIndex == index ? specialClass : ''">{{ item }}</div>
        </div>
        <div class="bottom-content" v-if="nodeShow === true">
          <div v-if="tabIndex === 0" @click="changeAction(index)" v-for="(item, index) in nodeActions" :key="index" class="node-item node-item-one">
            <div :class="item.class" class="node-item-icon"></div>
            <div>{{ item.name }}</div>
          </div>
          <div v-if="tabIndex === 1" @click="changeJudge(index)" v-for="(item, index) in nodeConditions" :key="index" class="node-item node-item-two">
            <div :class="item.class" class="node-item-icon" style="background: #D893F2"></div>
            <div>{{ item.name }}</div>
          </div>
          <div v-if="tabIndex === 2" @click="changeControl(index)" v-for="(item, index) in nodeProcess" :key="index" class="node-item node-item-three">
            <div :class="item.class" class="node-item-icon" style="background: #FF8888"></div>
            <div>{{ item.name }}</div>
          </div>
        </div>
        <!--动作-->
        <customer-attribute v-if="nodeAction === 2" style="margin-top: 20px"></customer-attribute>
        <add-group v-if="nodeAction === 3" style="margin-top: 20px"></add-group>
        <remove-group v-if="nodeAction === 4" style="margin-top: 20px"></remove-group>
        <template-message v-if="nodeAction === 5" style="margin-top: 20px"></template-message>
        <send-red-packets v-if="nodeAction === 6" style="margin-top: 20px"></send-red-packets>
        <wechatReply @transform="getWechatReply" v-if="nodeAction === 0" style="margin-top: 20px"></wechatReply>
        <message @change="getSmsChoose" v-if="nodeAction === 1" style="margin-top: 20px"></message>
        <!--条件判断-->
        <event-judge v-if="nodeJudge === 1" style="margin-top: 20px"></event-judge>
        <attribute-branch v-if="nodeJudge === 2" style="margin-top: 20px"></attribute-branch>
        <attrJudge @sendSearchTerms="getSearchTerms" v-if="nodeJudge === 0" style="margin-top: 20px"></attrJudge>
        <!--流程控制-->
        <wait @getWait="getWait" v-if="nodeControl === 0" style="margin-top: 20px"></wait>
      </div>
      <div v-if="nodeAction !== '' || nodeJudge !== '' || nodeControl !== ''" slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button @click="chooseNode === false" style="margin-left: 20px">取 消</el-button>
        <el-button type="primary">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import wechatReply from './../auto-process-components/wechat-reply.vue'
import templateMessage from './../auto-process-components/template-message.vue'
import removeGroup from './../auto-process-components/remove-group.vue'
import customerAttribute from './../auto-process-components/customer-attribute.vue'
import addGroup from './../auto-process-components/add-group.vue'
import sendRedPackets from './../auto-process-components/send-red-packets.vue'
import message from './../auto-process-components/message.vue'
import attrJudge from './../auto-process-components/attr-judge.vue'
import eventJudge from './../auto-process-components/event-judge.vue'
import attributeBranch from './../auto-process-components/attribute-branch.vue'
import wait from './../auto-process-components/wait.vue'
export default {
  name: 'falseModel',
  data () {
    return {
      specialClass: 'active-one',
      chooseNode: false,
      navs: ['动作', '条件控制', '流程控制'],
      tabIndex: 0,
      nodeActions: [
        {
          name: '微信回复',
          class: 'iconfont icon-wechat'
        },
        {
          name: '短信',
          class: 'iconfont icon-duanxin'
        },
        {
          name: '客户属性',
          class: 'iconfont icon-kehu'
        },
        {
          name: '加入群组',
          class: 'iconfont icon-jiarubanji'
        },
        {
          name: '移出群组',
          class: 'iconfont icon-huiyuanyichu'
        },
        {
          name: '模板消息',
          class: 'iconfont icon-navicon-dxmbwh'
        },
        {
          name: '发送红包',
          class: 'iconfont icon-hongbao'
        }
      ],
      nodeConditions: [
        {
          name: '属性判断',
          class: 'iconfont icon-gongrenshuxing'
        },
        {
          name: '事件判断',
          class: 'iconfont icon-shijianguanli'
        },
        {
          name: '属性多分支',
          class: 'iconfont icon-84'
        }
      ],
      nodeProcess: [
        {
          name: '等待',
          class: 'iconfont icon-dengdai'
        },
        {
          name: '结束',
          class: 'iconfont icon-zhaobiaojieshu'
        }
      ],
      nodeShow: true,
      nodeAction: '',
      nodeJudge: '',
      nodeControl: '',
      smsContent: {}, // 短信传过来的值
      wechatReplyContent: {}, // 微信回复传过来的值
      attrJudgeContent: {}, // 属性判断传过来的值
      waitTime: {} // 等待传过来的值
    }
  },
  computed: {
  },
  methods: {
    // 切换大的节点
    changeTabs(index) {
      this.tabIndex = index
      this.nodeShow = true
      this.nodeAction = ''
      this.nodeJudge = ''
      this.nodeControl = ''
      if (this.tabIndex === 0) {
        this.specialClass = 'active-one'
      } else if (this.tabIndex === 1) {
        this.specialClass = 'active-two'
      } else {
        this.specialClass = 'active-three'
      }
      // 只要切换这个大的导航 就进行清空(记得在打开弹窗的时候再清空一遍)
      this.smsContent = {}
      this.wechatReplyContent = {}
      this.attrJudgeContent = {}
      this.waitTime = {}
    },
    // 切换动作
    changeAction(index) {
      this.nodeAction = index
      this.nodeShow = false
    },
    // 切换判断
    changeJudge(index) {
      this.nodeJudge = index
      this.nodeShow = false
    },
    // 切换流程控制
    changeControl(index) {
      this.nodeControl = index
      this.nodeShow = false
    },
    // 获取短信子组件的值
    getSmsChoose(value) {
      this.smsContent = value
    },
    // 获取微信回复子组件的值
    getWechatReply(value) {
      this.wechatReplyContent = value
    },
    // 获取属性判断子组件的值
    getSearchTerms(value) {
      this.attrJudgeContent = value
    },
    // 获取等待时间
    getWait(value) {
      this.waitTime = value
    }
  },
  components: {
    wechatReply,
    customerAttribute,
    templateMessage,
    removeGroup,
    addGroup,
    sendRedPackets,
    message,
    attrJudge,
    eventJudge,
    attributeBranch,
    wait
  },
  watch: {
  },
  created() {
  }
}
</script>

<style scoped>
  .top-nav{
    height: 42px;
    display: flex;
    justify-content: flex-start;
  }
  .top-nav div{
    border-top: 1px solid #ccc;
    border-right: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    width: 152px;
    height: 40px;
    line-height: 40px;
    cursor: pointer;
  }
  .top-nav div:first-child{
    border-left: 1px solid #ccc;
  }
  .active-one{
    background: #4DA2ED;
    color: #fff;
  }
  .active-two{
    background: #D893F2;
    color: #fff;
  }
  .active-three{
    background: #FF8888;
    color: #fff;
  }
  .bottom-content{
    overflow: hidden;
    padding-top: 20px;
  }
  .node-item{
    width: 20%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
    float: left;
    cursor: pointer;
  }
  .node-item-icon{
    width: 45px;
    height: 45px;
    border-radius: 10px;
    background: #4DA2ED;
    color: #fff;
    font-size: 28px;
    line-height: 45px;
    text-align: center;
    margin-bottom: 10px;
  }
  .node-item-one:hover .node-item-icon{
    -moz-box-shadow:0 0 18px #4DA2ED;
    -webkit-box-shadow:0 0 18px #4DA2ED;
    box-shadow:0 0 18px #4DA2ED;
  }
  .node-item-two:hover .node-item-icon{
    -moz-box-shadow:0 0 18px #D893F2;
    -webkit-box-shadow:0 0 18px #D893F2;
    box-shadow:0 0 18px #D893F2;
  }
  .node-item-three:hover .node-item-icon{
    -moz-box-shadow:0 0 18px #FF8888;
    -webkit-box-shadow:0 0 18px #FF8888;
    box-shadow:0 0 18px #FF8888;
  }
</style>
